import io.ktor.client.HttpClient
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import location.PlatformGeoLocation
import model.DataRepository
import model.NavigationRepository
import model.NetworkController
import model.impl.DefaultDataRepository
import model.impl.DefaultNavigationRepository
import model.impl.NetworkControllerKtor
import model.network.FlavorInjectedHttpClient
import navigation.Navigation
import org.koin.core.module.dsl.bind
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.scopedOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.qualifier.named
import org.koin.dsl.module
import org.koin.ext.getFullName
import persistence.MultiPlatformSettingsPersistence
import persistence.Persistence
import persistence.TimedOutPersistence
import persistence.TokenPersistence
import ui.NavigationViewModel
import ui.ScopeHolderFactory
import ui.consumerInformation.ConsumerInformationViewModel
import ui.demoMerchantAdmin.DemoMerchantViewModel
import ui.eReceipt.EReceiptViewModel
import ui.login.LoginViewModel
import ui.merchantInformation.MerchantInformationViewModel
import ui.nearMe.NearMeViewModel
import ui.search.SearchViewModel

val appModules = module {
    factory<CoroutineDispatcher> { Dispatchers.Default }
    single<CoroutineScope> { CoroutineScope(get<CoroutineDispatcher>() + SupervisorJob() + globalCoroutineExceptionHandler) }

    single<HttpClient> { FlavorInjectedHttpClient(get()).getClient() }
    single<Flavor> { getFlavor() }
    single<ConfigFile> { getClientConfig() }

    factoryOf(::NetworkControllerKtor) { bind<NetworkController>() }
    singleOf(::TokenPersistence)
    singleOf(::TimedOutPersistence)
    singleOf(::DefaultDataRepository) { bind<DataRepository>() }
    single { params -> Navigation(params.get(), params.get()) }
    singleOf(::DefaultNavigationRepository) { bind<NavigationRepository>() }
    singleOf(::MultiPlatformSettingsPersistence) { bind<Persistence>() }

    singleOf(::NavigationViewModel)

    scope(named(EReceiptViewModel::class.getFullName())) {
        scopedOf(::EReceiptViewModel)
    }

    scope(named(MerchantInformationViewModel::class.getFullName())) {
        scopedOf(::MerchantInformationViewModel)
    }

    scope(named(SearchViewModel::class.getFullName())) {
        scopedOf(::SearchViewModel)
    }

    scope(named(DemoMerchantViewModel::class.getFullName())) {
        scopedOf(::DemoMerchantViewModel)
    }

    scope(named(LoginViewModel::class.getFullName())) {
        scopedOf(::LoginViewModel)
    }

    scope(named(ConsumerInformationViewModel::class.getFullName())) {
        scopedOf(::ConsumerInformationViewModel)
    }

    singleOf(::ScopeHolderFactory)

    singleOf(::PlatformGeoLocation)

    scope(named(NearMeViewModel::class.getFullName())) {
        scopedOf(::NearMeViewModel)
    }
}